import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Unauthorized.css';

export default function Unauthorized() {
  const navigate = useNavigate();

  return (
    <div className="unauthorized-container">
      <div className="unauthorized-card">
        <div className="error-icon">🔒</div>
        <h1>Access Denied</h1>
        <p>You don't have permission to access this page.</p>
        
        <div className="error-details">
          <p>Your current role does not have access to this resource.</p>
        </div>

        <div className="button-group">
          <button 
            onClick={() => navigate('/dashboard')}
            className="btn-primary"
          >
            Go to Dashboard
          </button>
          <button 
            onClick={() => navigate('/login')}
            className="btn-secondary"
          >
            Login as Different User
          </button>
        </div>
      </div>
    </div>
  );
}